/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('headersEditor', [
  '$timeout',
  function ($timeout) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./headers-editor.html'),

      replace: true,

      scope: {
        headers: '=ngModel',
      },

      link(scope, element, attrs) {},
    };
  },
]);
